import { go, html, strMap, take } from 'fxjs/es';
import { MShopAppProductItemTmplS } from '../../../MShop/App/Product/Item/S/Tmpl/module/MShopAppProductItemTmplS.js';
import { NessAppPlusHomeTmplS } from '../../../Ness/App/Plus/Home/S/Tmpl/module/NessAppPlusHomeTmplS.js';
import { NESS_CUSTOM_USER_PRODUCT_LIST_URL } from '../../../Ness/S/Constant/custom.js';
import { NessCoreConstantS } from '../../../Ness/Core/S/Constant/module/NessCoreConstantS.js';
import { NessCoreTmplS } from '../../../Ness/Core/S/Tmpl/module/NessCoreTmplS.js';
import $dataStr from 'fxdom/es/dataStr.js';

/**
 * Ness Labs ProductDetail 용 상품목록
 * @param products
 * @returns {*}
 */
export const makeLabsRecommendProductList = (products = []) => {
  return html`
    <div class="maple-labs-recommend">
      ${NessAppPlusHomeTmplS.homeTitle({
        link: NESS_CUSTOM_USER_PRODUCT_LIST_URL(),
        title: 'My MapleStory LABS',
        sub_title: '나만의 메이플스토리 랩스',
        title_color: NessCoreConstantS.colors.black,
        sub_title_color: NessCoreConstantS.colors.black,
      })}
      <div class="maple-labs-recommend__swiper swiper">
        <div class="maple-labs-recommend__product-list swiper-wrapper">
          ${html`${go(
            products,
            take(5),
            strMap((product) => {
              return html` <div
                class="swiper-slide maple-labs-recommend__product-list-item"
                data-fx-json="${$dataStr(product)}"
              >
                ${MShopAppProductItemTmplS.item(['v2'], 'swiper-slide app-async-product-item')(product)}
              </div>`;
            }),
          )}`}
        </div>
      </div>
    </div>
  `;
};

export const makeLabsCharacterMotionBtn = () => {
  return html`<div>
    <button class="change_motion" type="button">
      캐릭터 감정 / 모션 바꾸기${NessCoreTmplS.getSmileIcon()}
    </button>
  </div>`;
};

export const makeLabsEditPD = () => {
  // ! 추가 에디터 작업이 필요한 상품일때만 그리기
  return html`
    <div class="pd-edit">
      <div class="pd-field edit">
        <div class="maple-labs-edit__question">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM9.05 12H6.94V10.44H9.05V12ZM8.93 9.71H7.07L6.95 4H9.06L8.94 9.71H8.93Z"
              fill="#9F9F9F"
            /></svg
          >편집 적용 주의사항
        </div>
        <div class="pd-field__label">Option</div>
        <button class="pd-edit-btn" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_19130_46976)">
              <path d="M14.8 2L13.2 3.59998L16.4 6.79999L18 5.20001L14.8 2Z" fill="black" />
              <path
                d="M2.56915 14.2308L2 18L5.76917 17.4309L15.6 7.59998L12.4 4.39996L2.56915 14.2308Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_19130_46976">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs></svg
          >Edit
        </button>
      </div>
    </div>
  `;
};

export const makeNoticeHtml = () => {
  return html`<div class="tippy-ness_labs_notice">
    <div class="tippy-ness_labs_notice__title">My MapleStory Labs</div>
    <div class="tippy-ness_labs_notice__contents">
      나만의 메이플스토리 커스텀 옵션 적용 시 넥슨에센셜이 고려한 조건과 달라져 일부 이미지가 잘리거나, 가려질
      수 있습니다.
      <br />
      페이지 이탈 시 설정한 커스텀 옵션은 초기화됩니다.<br />
      커스텀 옵션 반영 문제로 인한 교환 및 환불은 불가합니다.
    </div>
  </div>`;
};

export const categoryListHtml = (labs_product_cate_lists) =>
  html` <div class="ness-plus-product-list__labs-category product-detail_cate_header">
    <ul class="labs__category">
      ${go(
        labs_product_cate_lists,
        strMap(({ id, name, selected }) => {
          const selected_class = selected ? 'selected' : '';
          return html`
            <li class="labs__category__item ${selected_class} category" data-id="${id}">
              <span class="labs__category__cate_list_name">${name}</span>
            </li>
          `;
        }),
      )}
    </ul>
  </div>`;
